module.exports = __webpack_public_path__ + "static/media/character-1.3da80e0d.gif";